import { ZButton } from "@/shared/components/button";
import { ZInput } from "@/shared/components/input";
import {
  ZModal,
  ZModalBody,
  ZModalContent,
  ZModalFooter,
  ZModalHeader,
} from "@/shared/components/modal";
import { Loader2 } from "lucide-react";
import { useState } from "react";

interface CreateFormModalProps {
  isOpen: boolean;
  onSubmit: (vendorName: string, productName: string | null) => Promise<void>;
}

const CreateFormModal: React.FC<CreateFormModalProps> = ({
  isOpen,
  onSubmit,
}) => {
  const [vendorName, setVendorName] = useState("");
  const [productName, setProductName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleProceed = async () => {
    if (!vendorName.trim()) {
      setError("Third-Party name is required");
      return;
    }
    setError("");
    setLoading(true);
    try {
      await onSubmit(vendorName.trim(), productName.trim() || null);
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ZModal isOpen={isOpen} hideCloseButton isDismissable={false}>
      <ZModalContent>
        <ZModalHeader className="flex flex-col gap-1">
          <h3 className="text-lg font-semibold">
            Conduct Third-Party Risk Assessment
          </h3>
          <p className="text-sm text-gray-500 font-normal">
            Zania will use AI to conduct comprehensive third-party evaluation.
          </p>
        </ZModalHeader>
        <ZModalBody className="flex flex-col gap-4">
          <ZInput
            label="Third-Party"
            placeholder="Enter third-party name"
            isRequired
            value={vendorName}
            onChange={(e) => {
              setVendorName(e.target.value);
              if (error) setError("");
            }}
            isInvalid={!!error}
            errorMessage={error}
            variant="faded"
          />
          <ZInput
            label="Product"
            placeholder="Enter product name (optional)"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
            variant="faded"
          />
        </ZModalBody>
        <ZModalFooter>
          <ZButton
            className="w-full"
            onClick={() => void handleProceed()}
            isDisabled={loading}
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Please Wait
              </>
            ) : (
              "Proceed"
            )}
          </ZButton>
        </ZModalFooter>
      </ZModalContent>
    </ZModal>
  );
};

export default CreateFormModal;
